import { useNavigate } from 'react-router-dom';

import { PaywallPrompt } from '../PaywallPrompt';
import { resolvePaywallDestination } from '../resolvePaywallDestination';

import type { PaywallBoundaryFallbackProps } from './PaywallBoundary.types';
import type React from 'react';

/**
 * The paywall card the boundary renders when it latches. Split out as a
 * function component so it can use router hooks — the boundary itself is a
 * class (error boundaries must be) and cannot call `useNavigate`.
 *
 * Defaults the CTA to a client-side navigation to the internal upgrade route
 * (`resolvePaywallDestination`, honor-but-coalesce); a caller can override via
 * `onUpgrade`.
 */
export function PaywallBoundaryFallback({
  error,
  onUpgrade,
  className,
}: PaywallBoundaryFallbackProps): React.JSX.Element {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade(error);
      return;
    }
    navigate(resolvePaywallDestination(error));
  };

  return (
    <PaywallPrompt
      error={error}
      variant="card"
      onUpgrade={handleUpgrade}
      className={className}
    />
  );
}

export default PaywallBoundaryFallback;
